module.exports = __webpack_public_path__ + "img/b2.736ad51c.png";